module.exports = ".input-group-addon {\n  width: unset !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/header-search/header-search.component.scss
// module id = ./src/app/shared-components/header-search/header-search.component.scss
// module chunks = main